import React from "react";
import CategoryCard from "../CategoryCard/CategoryCard";
import styles from "./CategoriesAndWebShopLinks.module.scss";

// Images
import OutdoorClassroomsImage from "./img/webp/outdoor-classrooms.webp";
import OutdoorClassroomsGraphic from "./img/svg/outdoor-classrooms-graphic.svg";
import ActivePlayImage from "./img/webp/active-play.webp";
import ActivePlayGraphic from "./img/svg/active-play-graphic.svg";
import ImaginativeCreativeImage from "./img/webp/imaginative-creative.webp";
import ImaginativeCreativeGraphic from "./img/svg/imaginative-and-creative-graphic.svg";
import SportImage from "./img/webp/sport.webp";
import SportGraphic from "./img/svg/sport-graphic.svg";
import FurnitureFencingStorageImage from "./img/webp/furniture-fencing-storage.webp";
import FurnitureFencingStorageGraphic from "./img/svg/furniture-fencing-storage-graphic.svg";
import SurfacingLandscapingImage from "./img/webp/surfacing-landscaping.webp";
import SurfacingLandscapingGraphic from "./img/svg/surfacing-landscaping-graphic.svg";
import EarlyYearsImage from "./img/webp/early-years-furniture.webp";
import EarlyYearsGraphic from "./img/svg/indoor-classrooms-graphic.svg";
import FreestandingProductsImage from "./img/webp/easel.webp";
import FreestandingProductsGraphic from "./img/svg/freestanding-products-graphic.svg";
import { ProductCategory } from "../../helpers/GoogleTagManager/types/ProductCategory";
import { CustomEventLocation } from "../../helpers/GoogleTagManager/types/CustomEventLocation";

const CategoriesAndWebShopLinks = () => {
    return (
        <section className={styles.categoryCardsContainer}>
            <div className={styles.categoryCardsGridWrapper}>
                <CategoryCard
                    imageURL={OutdoorClassroomsImage}
                    imageAltText="Pentagon Play outdoor classroom products"
                    backgroundGraphicURL={OutdoorClassroomsGraphic}
                    backgroundShadow="peel-shadow"
                    title={ProductCategory.OUTDOOR_CLASSROMS}
                    cardColor="#cde6ff"
                    buttonColor="#499fd4"
                    buttonHoverColor="#188abf"
                    buttonLink="https://www.pentagonplay.co.uk/products/outdoor-classrooms"
                    dataLayerConfig={{
                        location: CustomEventLocation.CATEGORY_CARD,
                        productCategory: ProductCategory.OUTDOOR_CLASSROMS,
                    }}
                />
                <CategoryCard
                    imageURL={ActivePlayImage}
                    imageAltText="Pentagon Play active play products"
                    backgroundGraphicURL={ActivePlayGraphic}
                    backgroundShadow="peel-shadow"
                    title={ProductCategory.ACTIVE_PLAY}
                    cardColor="#fff0b9"
                    buttonColor="#dbc13d"
                    buttonHoverColor="#c2a724"
                    buttonLink="https://www.pentagonplay.co.uk/products/active-play"
                    dataLayerConfig={{
                        location: CustomEventLocation.CATEGORY_CARD,
                        productCategory: ProductCategory.ACTIVE_PLAY,
                    }}
                />
                <CategoryCard
                    imageURL={ImaginativeCreativeImage}
                    imageAltText="Pentagon Play imaginative and creative products"
                    backgroundGraphicURL={ImaginativeCreativeGraphic}
                    backgroundShadow="peel-shadow"
                    title={ProductCategory.IMAGINATION_AND_CREATIVE}
                    cardColor="#ffbe96"
                    buttonColor="#ff8714"
                    buttonHoverColor="#e06c00"
                    buttonLink="https://www.pentagonplay.co.uk/products/imaginative-and-creative"
                    dataLayerConfig={{
                        location: CustomEventLocation.CATEGORY_CARD,
                        productCategory:
                            ProductCategory.IMAGINATION_AND_CREATIVE,
                    }}
                />
                <CategoryCard
                    imageURL={EarlyYearsImage}
                    imageAltText="storage and seating in a nursery school"
                    backgroundGraphicURL={EarlyYearsGraphic}
                    backgroundShadow="peel-shadow"
                    title={ProductCategory.EARLY_YEARS_FURNITURE}
                    cardColor="#e0e0f2"
                    buttonColor="#a8a8e9"
                    buttonHoverColor="hsl(240, 60%, 69%)"
                    buttonLink="https://www.pentagonplay.co.uk/products/early-years-furniture"
                    dataLayerConfig={{
                        location: CustomEventLocation.CATEGORY_CARD,
                        productCategory: ProductCategory.EARLY_YEARS_FURNITURE,
                    }}
                />
                <CategoryCard
                    imageURL={FurnitureFencingStorageImage}
                    imageAltText="Pentagon Play furniture, fencing and storage products"
                    backgroundGraphicURL={FurnitureFencingStorageGraphic}
                    backgroundShadow="peel-shadow"
                    title={ProductCategory.FURNITURE_FENCING_STORAGE}
                    cardColor="#ebd7f0"
                    buttonColor="#e678c8"
                    buttonHoverColor="#df4eb8"
                    buttonLink="https://www.pentagonplay.co.uk/products/furniture-fencing-and-storage"
                    dataLayerConfig={{
                        location: CustomEventLocation.CATEGORY_CARD,
                        productCategory:
                            ProductCategory.FURNITURE_FENCING_STORAGE,
                    }}
                />
                <CategoryCard
                    imageURL={SurfacingLandscapingImage}
                    imageAltText="Pentagon Play surfacing and landscaping products"
                    backgroundGraphicURL={SurfacingLandscapingGraphic}
                    backgroundShadow="peel-shadow"
                    title={ProductCategory.SURFACING_LANDSCAPING}
                    cardColor="#fa828c"
                    buttonColor="#e63c5f"
                    buttonHoverColor="#d41c40"
                    buttonLink="https://www.pentagonplay.co.uk/products/surfacing-and-landscaping"
                    dataLayerConfig={{
                        location: CustomEventLocation.CATEGORY_CARD,
                        productCategory: ProductCategory.SURFACING_LANDSCAPING,
                    }}
                />
                <CategoryCard
                    imageURL={SportImage}
                    imageAltText="Pentagon Play sport products"
                    backgroundGraphicURL={SportGraphic}
                    backgroundShadow="peel-shadow"
                    title={ProductCategory.SPORT}
                    cardColor="#c8b4d7"
                    buttonColor="#a03287"
                    buttonHoverColor="#782665"
                    buttonLink="https://www.pentagonplay.co.uk/products/sport"
                    dataLayerConfig={{
                        location: CustomEventLocation.CATEGORY_CARD,
                        productCategory: ProductCategory.SPORT,
                    }}
                />
                <CategoryCard
                    imageURL={FreestandingProductsImage}
                    imageAltText="Pentagon Play surfacing and landscaping products"
                    backgroundGraphicURL={FreestandingProductsGraphic}
                    backgroundShadow="peel-shadow"
                    title="Freestanding Products"
                    cardColor="#80d886"
                    buttonColor="#347f4f"
                    buttonHoverColor="#255b39"
                    buttonLink="https://www.pentagonplay.co.uk/products/shop-online"
                    dataLayerConfig={{
                        location: CustomEventLocation.CATEGORY_CARD,
                    }}
                />
            </div>
        </section>
    );
};

export default CategoriesAndWebShopLinks;
